/* istanbul ignore file */
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./preview.css"
import App from "./App";
import "@fontsource/open-sans";

ReactDOM.render(<App />, document.getElementById("root"));
